/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_NameInputs */

const en_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert speaker name`)
};

const fr_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer le nom de l'intervenant`)
};

const de_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprechernamen einfügen`)
};

const it_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome dell'oratore`)
};

const ru_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте имя докладчика`)
};

const es_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar el nombre del orador`)
};

const zh_cn2_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入演讲者姓名`)
};

const ja_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカー名を挿入`)
};

const hi_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता का नाम डालें`)
};

const pt_pt2_insert_speaker_name = /** @type {(inputs: Insert_Speaker_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o nome do palestrante`)
};

/**
* | output |
* | --- |
* | "Insert speaker name" |
*
* @param {Insert_Speaker_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_name = /** @type {((inputs?: Insert_Speaker_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_name(inputs)
	if (locale === "de") return de_insert_speaker_name(inputs)
	if (locale === "it") return it_insert_speaker_name(inputs)
	if (locale === "ru") return ru_insert_speaker_name(inputs)
	if (locale === "es") return es_insert_speaker_name(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_name(inputs)
	if (locale === "ja") return ja_insert_speaker_name(inputs)
	if (locale === "hi") return hi_insert_speaker_name(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_name(inputs)
	return en_insert_speaker_name(inputs)
});